'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);

/**
 * Utility class for url & query string forgery.
 */
ngModule.factory("urlUtils", function () {
  return {
    /**
     * Remove the query string from an url.
     *
     * i.e : https://www.taelys.com/mypage?foo=bar -> https://www.taelys.com/mypage
     */
    removeQueryString: function removeQueryString(url) {
      var qsStart = url.indexOf("?");
      return qsStart === -1 ? url : url.slice(0, qsStart);
    },
    /**
     * Retrieve the query string from an url.
     *
     * i.e : http://www.google.fr?foo=bar&q=hello -> foo=bar&q=hello
     */
    getQueryString: function getQueryString(url) {
      if (!_.isString(url)) {
        return "";
      }
      var qsStart = url.indexOf("?");
      if (qsStart !== -1) {
        return url.slice(qsStart + 1);
      } else {
        return "";
      }
    },
    /**
     * Add given parameter map to given url.
     * null or undefined values will be ignored.
     *
     * i.e : http://www.google.com?foo=bar  + { q : "lala" } ->  http://www.google.fr?foo=bar&q=lala
     */
    addParams: function addParams(url, params) {
      var queryString = this.getQueryString(url);
      var paramsObj = this.deparam(queryString);
      var extendedParams = _.extend(paramsObj, _.pickBy(params, function (value, key) {
        return value != null;
      }));
      return this.removeQueryString(url) + "?" + this.param(extendedParams);
    },
    /**
     * Transform given map to query string.
     * null or undefined values will be ignored.
     *
     * i.e : { foo : "bar", q : "lala" }  -> foo=bar&q=lala
     */
    param: function param(object) {
      return $.param(_.pickBy(object, function (value, key) {
        return value != null;
      }), true);
    },
    /**
     * Transform given query string to param map
     *
     * i.e : foo=bar&q=lala -> { foo : "bar", q : "lala" }
     */
    deparam: function deparam(params, coerce) {
      var obj = {},
        coerce_types = {
          'true': !0,
          'false': !1,
          'null': null
        };
      $.each(params.replace(/\+/g, ' ').split('&'), function (j, v) {
        var param = v.split('='),
          key = decodeURIComponent(param[0]),
          val,
          cur = obj,
          i = 0,
          keys = key.split(']['),
          keys_last = keys.length - 1;
        if (/\[/.test(keys[0]) && /\]$/.test(keys[keys_last])) {
          keys[keys_last] = keys[keys_last].replace(/\]$/, '');
          keys = keys.shift().split('[').concat(keys);
          keys_last = keys.length - 1;
        } else {
          keys_last = 0;
        }
        if (param.length === 2) {
          val = decodeURIComponent(param[1]);
          if (coerce) {
            val = val && !isNaN(val) ? +val : val === 'undefined' ? undefined : coerce_types[val] !== undefined ? coerce_types[val] : val;
          }
          if (keys_last) {
            for (; i <= keys_last; i++) {
              key = keys[i] === '' ? cur.length : keys[i];
              cur = cur[key] = i < keys_last ? cur[key] || (keys[i + 1] && isNaN(keys[i + 1]) ? {} : []) : val;
            }
          } else {
            if ($.isArray(obj[key])) {
              obj[key].push(val);
            } else if (obj[key] !== undefined) {
              obj[key] = [obj[key], val];
            } else {
              obj[key] = val;
            }
          }
        } else if (key) {
          obj[key] = coerce ? undefined : '';
        }
      });
      return obj;
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/core/utils/urlUtils.js
// module id = 2767
// module chunks = 13